import { useSearchParams } from 'react-router-dom'; // Import for query parameters
import { useState } from 'react'; // Import for state management

export const initialGraphState = {
  nodes: [{ id: 'node1', name: 'Loading...', x: 0, y: 0, z: 0 }],
  links: [],
};

export const initialSettingsState = {
  selectedFile: 'obama_v_others_2007_2011_graph.json',
  disableInitialSwitch: false,
  nodeSize: 50,
  isDarkMode: true,
};

// Custom Hook to initialize app state
export function useInitializeAppState() {
  const [searchParams] = useSearchParams();

  // Extract query parameters
  const darkModeQuery = searchParams.get('darkMode');
  const initialSwitchQuery = searchParams.get('initialSwitch');
  const nodeSizeQuery = searchParams.get('nodeSize');
  const selectedFileQuery = searchParams.get('selectedFile');

  // Initialize states based on query parameters or defaults
  const isDarkMode = darkModeQuery !== null ? darkModeQuery === 'true' : initialSettingsState.isDarkMode;
  const disableInitialSwitch =
    initialSwitchQuery !== null ? initialSwitchQuery === 'true' : initialSettingsState.disableInitialSwitch;
  const nodeSize = nodeSizeQuery !== null && !isNaN(Number(nodeSizeQuery))
    ? Number(nodeSizeQuery)
    : initialSettingsState.nodeSize;
  const selectedFile = selectedFileQuery || initialSettingsState.selectedFile;

  let graphState = initialGraphState;

  // If initial switch is disabled, load the first file by default
  if (!disableInitialSwitch && selectedFile) {
    try {
      const file = require(`../data/${selectedFile}`);
      graphState = file;
    } catch (error) {
      console.error(`Error loading file: ${selectedFile}`, error);
    }
  }

  let colorKey = 'default';

  return {
    graphState,
    selectedFile,
    disableInitialSwitch,
    nodeSize,
    isDarkMode,
    colorKey,
  };
}
